import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faAt, faPhone, faPrint, faChevronCircleLeft, faChevronCircleRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faAt)
library.add(faPhone)
library.add(faPrint)
library.add(faChevronCircleLeft)
library.add(faChevronCircleRight)

Vue.component('font-awesome-icon', FontAwesomeIcon)
